import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TreeNode } from "utils/tree";
import { SpaceWithParentAccessLevel } from "views/Account/Spaces/types";

const SpacesListLabelsCell = ({
  item: node,
  ...cellProps
}: TableSimpleCellProps<TreeNode<SpaceWithParentAccessLevel>>) => (
  <TableSimpleCell {...cellProps}>
    <TableCellLabels tags={node.item.labels} />
  </TableSimpleCell>
);

export default SpacesListLabelsCell;
